module.exports = __webpack_public_path__ + "img/bz.26d8c855.png";